module.exports = __webpack_public_path__ + "static/img/anxun.0134d9ef.png";